export default "__VITE_ASSET__386637af__"